import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, get } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const me = await get("/auth/me");
      setUser(me);
      return me;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };
  const can = (p) => !!user && (user.permissions?.includes("*") || user.permissions?.includes(p));
  return <Ctx.Provider value={{ user, setUser, refresh, logout, can }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
export const homeFor = (u) => (u?.role === "customer" ? "/portal" : "/crm");
